#import "./AssetFields.graphql"

mutation RecordAssetCheck(
  $assetId: ID!
  $source: AssetCheckSourceEnum!
  $result: AssetCheckResultEnum!
  $checkedOn: ISO8601Date
  $externalRef: String
  $notes: String
) {
  recordAssetCheck(
    input: {
      assetId: $assetId
      source: $source
      result: $result
      checkedOn: $checkedOn
      externalRef: $externalRef
      notes: $notes
    }
  ) {
    asset {
      ...AssetFields
    }
  }
}
